/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommentDto } from '../../models/comment-dto';
import { SetCommentResolvedRequest } from '../../models/set-comment-resolved-request';

export interface CommentsCommentIdResolvePost$Plain$Params {
  commentId: string;
      body?: SetCommentResolvedRequest
}

export function commentsCommentIdResolvePost$Plain(http: HttpClient, rootUrl: string, params: CommentsCommentIdResolvePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
  const rb = new RequestBuilder(rootUrl, commentsCommentIdResolvePost$Plain.PATH, 'post');
  if (params) {
    rb.path('commentId', params.commentId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommentDto>;
    })
  );
}

commentsCommentIdResolvePost$Plain.PATH = '/comments/{commentId}/resolve';
